<template>
  <div class="row">
    <div class="col-12 active">
      <div class="card active">
        <div class="card-body mini-nav bg-primary pt-2 pb-3 active ">
          <nav class="navbar navbar-expand-md navbar navbar-dark bg-primary py-2 active">
            <button
                class="navbar-toggler btn btn-sm px-3 font-size-16 header-item waves-effect h-auto text-primary"
                type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup"
                aria-controls="navbarNavAltMarkup" aria-expanded="false"
                aria-label="Toggle navigation">
              <span class="mdi mdi-menu"></span>
            </button>
            <div class="collapse navbar-collapse justify-content-between active"
                 id="navbarNavAltMarkup">

              <div class="navbar-nav">
                <div class="navbar-nav">
                  <router-link v-if="getRight('MEDICAL QUICK STATS')" :to="{name: 'medical-dashboard'}" active-class="mm-active" class="nav-item nav-link">Quick Stats</router-link>
                  <router-link v-if="getRight('MEDICAL PENDING INVOICES')" :to="{name: 'cert-medical-pending'}" active-class="mm-active" class="nav-item nav-link">Pending Invoices</router-link>
                  <router-link v-if="getRight('MEDICAL PENDING APPROVAL')" :to="{name: 'pending-approval-medical'}" active-class="mm-active" class="nav-item nav-link">Pending Approval</router-link>
                  <router-link v-if="getRight('ACTIVE MEDICAL CERTIFICATES')" :to="{name: 'active-medical-cert'}" active-class="mm-active" class="nav-item nav-link">Active Certificates</router-link>
                  <router-link v-if="getRight('EXPIRED MEDICAL CERTIFICATES')" :to="{name: 'expired-medical-cert'}" active-class="mm-active" class="nav-item nav-link">Expired Certificates</router-link>
                  <router-link v-if="getRight('MEDICAL PAID BILLS')" :to="{name: 'medical-paid-bills'}" active-class="mm-active" class="nav-item nav-link">Medical Paid Bills</router-link>
                </div>
              </div>

              <div class="d-flex gap-2">
                <!-- Bulk Upload Button -->
                <button v-if="getRight('MEDICAL BULK UPLOAD')" class="btn btn-success waves-effect waves-light my-2 my-sm-0 text-uppercase"
                        data-bs-toggle="modal"
                        data-bs-target="#bulk_upload_modal">
                  <i class="mdi mdi-upload me-1"></i> Bulk Upload
                </button>

                <!-- Single Applicant Invoice Button -->
                <button v-if="getRight('MEDICAL INVOICE AN APPLICANT')" class="btn btn-info waves-effect waves-light my-2 my-sm-0 text-uppercase"
                        data-bs-toggle="modal"
                        data-bs-target="#medical_creation_modal">Invoice An Applicant</button>
              </div>

            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>


  <!-- Medical Certificate Bill Creation Modal (Keep existing) -->
  <div class="modal fade" id="medical_creation_modal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header liq-header">
          <h5 class="modal-title text-uppercase" id="myLargeModalLabel">Medical Certificate New Application</h5>
          <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Step 1: Search/Register Applicant -->
        <div class="modal-body pb-4 searching-modal-body">

          <div v-if="!assessmentInformation && !activityInformation && !invoiceDetails && !generatingInvoice" class="row">
            <div class="col-md-12 mb-3">
              <label for="">Search or Input Applicant Details</label>
              <select v-model="selectedMethod" class="form-select liq-search-method">
                <option value="">Select Search Method</option>
                <option value="search">Search Existing Applicant by ID Number</option>
                <option value="register" class="register">New Applicant</option>
              </select>
            </div>
          </div>

          <div class="row">

            <!-- Search for existing individual -->
            <div v-if="selectedMethod === 'search'" class="col-12 business-id-search">
              <label for="">Search For Applicant To Continue</label>
              <div class="input-group mb-3">
                <input v-model="searchIdNo" type="text" class="form-control" placeholder="Enter ID Number">
                <button @click="getIndividual()" type="button" class="btn btn-primary waves-effect waves-light search-bz-btn">
                  <i class="bx bx-search-alt-2 font-size-16 align-middle me-2"></i> Search
                </button>
              </div>

              <!-- Searching loader -->
              <div class="searching-biz-loader" v-if="individualSearch">
                <div class="loader-modal p-5">
                  <div class="d-flex align-items-center justify-content-center p-5 text-center flex-column">
                    <div class="spinner-border text-dark m-1" role="status">
                      <span class="sr-only fw-bold">Searching</span>
                    </div>
                    <p class="pt-4 fw-strong text-uppercase fw-bold">Please wait while we search for the applicant.</p>
                  </div>
                </div>
              </div>

              <!-- Search Results -->
              <div class="col-12 biz-search-results" v-if="individualDetailsResult">
                <table class="table table-sm text-uppercase table-striped">
                  <thead class="table-dark">
                  <th colspan="2">Search Results for Applicant with <span class="text-warning">ID No: {{individualDetails.idNo}}</span></th>
                  </thead>
                  <tbody>
                  <tr>
                    <th>Full Names</th>
                    <td>{{individualDetails.names}}</td>
                  </tr>
                  <tr>
                    <th>ID Number</th>
                    <td>{{individualDetails.idNo}}</td>
                  </tr>
                  <tr>
                    <th>Phone Number</th>
                    <td>{{individualDetails.phoneNumber}}</td>
                  </tr>
                  <tr>
                    <th>Email Address</th>
                    <td>{{individualDetails.email}}</td>
                  </tr>
                  <tr>
                    <th>Sub County</th>
                    <td>{{individualDetails.subCountyName}}</td>
                  </tr>
                  <tr>
                    <th>Ward</th>
                    <td>{{individualDetails.wardName}}</td>
                  </tr>
                  </tbody>
                </table>

                <div class="row">
                  <div class="col-12">
                    <button @click="proceedToAssessment()" type="button" class="btn btn-success waves-effect waves-light w-100 generate-invoice-btn">
                      <i class="mdi mdi-checkbox-multiple-marked font-size-16 align-middle me-2"></i> {{invoiceMessage}}
                    </button>
                  </div>
                </div>
              </div>

              <!-- No results found -->
              <div class="col-12 no-results" v-if="noResultsFound">
                <div class="p-4 border-radius border-solid border-primary border-2 d-flex flex-column align-items-center justify-content-center">
                  <div class="img mb-4 pt-3">
                    <img src="assets/images/no-result-found-icon.svg" style="height: 65px;" class="img" alt="">
                  </div>
                  <div class="text-center">
                    <h4 class="card-title text-uppercase text-dark">No Results Found</h4>
                    <p>The ID number you entered does not match any registered applicant. Please try again or register as a new applicant.</p>
                  </div>
                </div>
              </div>

            </div>

            <!-- Form for registering new applicant -->
            <div v-if="selectedMethod === 'register'" class="col-12 unregistered-biz-cont">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div class="mb-3">
                    <label for="" class="form-label">Full Names <span class="text-danger">*</span></label>
                    <input v-model="individualDetails.names" type="text" class="form-control" placeholder="Enter Full Names">
                  </div>
                </div>

                <div class="col-sm-12 col-md-6">
                  <div class="mb-3">
                    <label for="" class="form-label">ID Number <span class="text-danger">*</span></label>
                    <input v-model="individualDetails.idNo" type="text" class="form-control" placeholder="Enter ID Number">
                  </div>
                </div>

                <div class="col-sm-12 col-md-6">
                  <div class="mb-3">
                    <label for="" class="form-label">Phone Number <span class="text-danger">*</span></label>
                    <input v-model="individualDetails.phoneNumber" type="text" class="form-control" placeholder="e.g. 0712345678">
                  </div>
                </div>

                <div class="col-sm-12 col-md-6">
                  <div class="mb-3">
                    <label for="" class="form-label">Email Address <span class="text-danger">*</span></label>
                    <input v-model="individualDetails.email" type="email" class="form-control" placeholder="email@example.com">
                  </div>
                </div>

                <div class="col-sm-12 col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Sub County <span class="text-danger">*</span></label>
                    <select class="form-select" v-model="subCounty">
                      <option value="">Select Sub County</option>
                      <option v-for="(item, index) in subCounties" :value="item" :key="index">
                        {{ item.subCountyName }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-12 col-md-6">
                  <div class="mb-3">
                    <label class="form-label">Ward <span class="text-danger">*</span></label>
                    <select class="form-select" v-model="ward">
                      <option value="">Select Ward</option>
                      <option v-for="(item, index) in wards" :value="item" :key="index">
                        {{ item.wardName }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-12 col-md-6">
                  <div class="mb-3">
                    <label for="" class="form-label">Job Title/Occupation</label>
                    <input v-model="individualDetails.jobTitle" type="text" class="form-control" placeholder="e.g. Food Handler, Chef">
                  </div>
                </div>

                <div class="col-sm-12 col-md-6">
                  <div class="mb-3">
                    <label for="" class="form-label">Employer/Business Name</label>
                    <input v-model="individualDetails.employer" type="text" class="form-control" placeholder="Name of Employer or Business">
                  </div>
                </div>

                <div class="col-12">
                  <button @click="registerIndividual()" type="button" class="btn btn-success waves-effect waves-light w-100 generate-invoice-btn">
                    <i class="mdi mdi-checkbox-multiple-marked font-size-16 align-middle me-2"></i> {{invoiceMessage}}
                  </button>
                </div>
              </div>
            </div>

          </div>

        </div>

        <!-- Step 2: Medical Assessment Information -->
        <div v-if="assessmentInformation" class="modal-body pb-4">

          <div class="col-12">
            <div class="bg-info border-2 bg-soft p-3 mb-4">
              <p class="fw-semibold mb-0 pb-0">Applicant: <span class="text-primary">{{individualDetails.names}}</span> | ID: <span class="text-primary">{{individualDetails.idNo}}</span></p>
            </div>
          </div>

          <div class="col-12">
            <div class="bg-primary border-2 bg-soft p-3 mb-4">
              <p class="fw-semibold mb-0 pb-0">Medical Assessment Information</p>
            </div>
          </div>

          <!-- Tests Done -->
          <div class="col-12">
            <div class="mb-3">
              <label for="" class="form-label">Tests Done <span class="text-danger">*</span></label>
              <div v-for="(test, index) in testsDone" :key="index" class="input-group mb-2">
                <span class="input-group-text">{{index + 1}}.</span>
                <input v-model="testsDone[index]" type="text" class="form-control" placeholder="Enter test done">
                <button v-if="index > 0" @click="removeTest(index)" type="button" class="btn btn-danger">
                  <i class="bx bx-trash"></i>
                </button>
              </div>
              <button @click="addTest()" type="button" class="btn btn-outline-primary btn-sm">
                <i class="bx bx-plus"></i> Add Another Test
              </button>
            </div>
          </div>

          <!-- Observations/Recommendations -->
          <div class="col-12">
            <div class="mb-3">
              <label for="" class="form-label">Observations/Recommendations <span class="text-danger">*</span></label>
              <textarea v-model="observations" class="form-control" placeholder="Enter medical observations and recommendations" rows="4"></textarea>
            </div>
          </div>

          <!-- Checkbox to confirm -->
          <div class="col-12">
            <div class="form-check mb-3">
              <input class="form-check-input" type="checkbox" id="assessmentConfirm" v-model="assessmentConfirmed">
              <label class="form-check-label" for="assessmentConfirm">
                I confirm that the medical assessment has been completed and the applicant is fit for the medical certificate.
              </label>
            </div>
          </div>

          <div class="col-12">
            <div class="d-flex gap-2">
              <button @click="goBackToApplicant()" type="button" class="btn btn-secondary">
                <i class="mdi mdi-arrow-left me-1"></i> Back
              </button>
              <button @click="proceedToBilling()" type="button" class="btn btn-success flex-grow-1" :disabled="!assessmentConfirmed">
                <i class="mdi mdi-arrow-right me-1"></i> Proceed to Billing
              </button>
            </div>
          </div>

        </div>

        <!-- Step 3: Billing Selection -->
        <div v-if="activityInformation" class="modal-body pb-4">

          <div class="col-12">
            <div class="bg-info border-2 bg-soft p-3 mb-4">
              <p class="fw-semibold mb-0 pb-0">Applicant: <span class="text-primary">{{individualDetails.names}}</span> | ID: <span class="text-primary">{{individualDetails.idNo}}</span></p>
            </div>
          </div>

          <div class="col-12">
            <div class="bg-primary border-2 bg-soft p-3 mb-4">
              <p class="fw-semibold mb-0 pb-0">Billing Information</p>
            </div>
          </div>

          <div class="col-12">
            <div class="mb-3">
              <label for="" class="form-label">Categories</label>
              <select @change="getFeesAndCharges($event)" class="form-control bg-white" title="Select Category">
                <option value="">Select Options</option>
                <option v-for="(item, index) in incomeTypes" :value="item.incomeTypeId" :key="index">
                  {{ item.incomeTypeDescription }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-12">
            <div class="mb-3">
              <label for="" class="form-label">Sub Category</label>
              <select @change="selectedSubCategory($event)" class="form-control bg-white" title="Select Sub Categories">
                <option value="">Select Fee</option>
                <option v-for="(item, index) in feesAndCharges" :value="JSON.stringify(item)" :key="index">
                  {{ item.feeDescription }} - KES {{numberFormat(item.unitFeeAmount)}}
                </option>
              </select>
            </div>
          </div>

          <!-- Tests Summary -->
          <div class="col-12" v-if="filteredTestsDone.length > 0">
            <div class="mb-3">
              <label class="form-label">Tests Done Summary</label>
              <div class="bg-light p-3 rounded">
                <ul class="mb-0">
                  <li v-for="(test, index) in filteredTestsDone" :key="index">{{ test }}</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Observations Summary -->
          <div class="col-12" v-if="observations">
            <div class="mb-3">
              <label class="form-label">Observations/Recommendations</label>
              <div class="bg-light p-3 rounded">
                <p class="mb-0">{{ observations }}</p>
              </div>
            </div>
          </div>

          <!-- Other Applicable Charges Section -->
          <div class="col-12">
            <div class="bg-primary border-2 bg-soft p-3 mb-3">
              <p class="fw-semibold mb-0 pb-0">Other Applicable Charges</p>
            </div>
          </div>

          <div class="col-12">
            <div class="mb-3">
              <label class="form-label fw-semibold"><span class="badge bg-primary">Step 1</span> Select Charge Category</label>
              <div class="d-flex gap-2">
                <select v-model="selectedOtherCategory" class="form-control" @change="handleCategoryChange">
                  <option :value="null">-- Select a category --</option>
                  <option v-for="(category, index) in otherChargeCategories" :key="index" :value="category">{{ category.incomeTypeDescription }}</option>
                </select>
                <button type="button" class="btn btn-outline-primary d-flex align-items-center gap-1" @click="toggleCharges" style="white-space: nowrap; min-width: 100px;">
                  <i class="bx bx-refresh"></i><span>Toggle</span>
                </button>
              </div>
              <div class="d-flex align-items-center gap-2 mt-1">
                <span class="badge" :class="showAllCharges ? 'bg-info' : 'bg-success'">{{ showAllCharges ? 'Showing all categories' : 'Showing filtered categories' }}</span>
                <small class="text-muted">({{ otherChargeCategories.length }} available)</small>
              </div>
            </div>
          </div>

          <div class="col-7" v-if="selectedOtherCategory && feesAndChargesOther.length > 0">
            <div class="mb-3">
              <label class="form-label fw-semibold"><span class="badge bg-success">Step 2</span> Select Specific Charge</label>
              <select v-model="selectedCharge" class="form-control">
                <option :value="null">-- Select a charge to add --</option>
                <option v-for="(charge, index) in feesAndChargesOther" :key="index" :value="charge">{{ charge.feeDescription }} - KES {{ numberFormat(charge.unitFeeAmount) }}</option>
              </select>
            </div>
          </div>

          <div class="col-3" v-if="selectedOtherCategory && feesAndChargesOther.length > 0">
            <div class="mb-3">
              <label class="form-label fw-semibold"><span class="badge bg-info">Step 3</span> Quantity</label>
              <input v-model.number="chargeQuantity" type="number" min="1" class="form-control" placeholder="1">
            </div>
          </div>

          <div class="col-2" v-if="selectedOtherCategory && feesAndChargesOther.length > 0">
            <div class="mb-3">
              <label class="form-label fw-semibold">&nbsp;</label>
              <button type="button" class="btn btn-success w-100" @click="addChargeToList" :disabled="!selectedCharge">
                <i class="bx bx-plus-circle"></i> Add
              </button>
            </div>
          </div>

          <div class="col-12" v-if="selectedOtherCategory && feesAndChargesOther.length === 0 && loadingOtherCharges">
            <div class="alert alert-warning"><i class="bx bx-loader bx-spin"></i> Loading charges for {{ selectedOtherCategory.incomeTypeDescription }}...</div>
          </div>

          <div class="col-12" v-if="addedCharges.length > 0">
            <div class="table-responsive">
              <table class="table table-nowrap vertical-align-middle table-bordered table-sm">
                <thead class="table-success">
                <tr class="text-uppercase">
                  <th>Charge Description</th>
                  <th width="100" class="text-center">Quantity</th>
                  <th width="130" class="text-end">Unit Price</th>
                  <th width="130" class="text-end">Total</th>
                  <th width="80" class="text-center">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in addedCharges" :key="index">
                  <td>{{ item.feeDescription }}</td>
                  <td class="text-center">{{ item.quantity }}</td>
                  <td class="text-end">KES {{ numberFormat(item.unitFeeAmount) }}</td>
                  <td class="text-end fw-bold">KES {{ numberFormat(item.unitFeeAmount * item.quantity) }}</td>
                  <td class="text-center">
                    <button type="button" class="btn btn-sm btn-danger" @click="removeCharge(index)"><i class="bx bx-trash"></i></button>
                  </td>
                </tr>
                </tbody>
                <tfoot class="table-info">
                <tr>
                  <th colspan="3" class="text-end text-uppercase">Grand Total:</th>
                  <th class="text-end fw-bold">KES {{ numberFormat(totalAddedCharges) }}</th>
                  <th></th>
                </tr>
                </tfoot>
              </table>
            </div>
          </div>

          <div class="col-12" v-if="addedCharges.length === 0">
            <div class="alert alert-info"><i class="bx bx-info-circle"></i> <strong>No additional charges added.</strong> Select a category and charge above if applicable.</div>
          </div>

          <!-- Computed Amount -->
          <div class="col-12 mt-4">
            <div class="bg-warning border-2 bg-soft p-3 mb-4">
              <p class="mb-0 pb-0 fw-semibold">Computed Amount</p>
              <div class="d-flex justify-content-between align-items-center mt-2">
                <div>
                  <small class="text-muted d-block">Base Fee:</small>
                  <small class="text-muted d-block">Other Charges:</small>
                </div>
                <div class="text-end">
                  <small class="d-block">KES {{ numberFormat(unitFeeAmount) }}</small>
                  <small class="d-block">KES {{ numberFormat(totalAddedCharges) }}</small>
                </div>
              </div>
              <hr class="my-2">
              <h4 class="fw-bold mb-0 pb-0">KES {{ numberFormat(totalComputedAmount) }}</h4>
            </div>
          </div>

          <div class="col-12">
            <div class="d-flex gap-2">
              <button @click="goBackToAssessment()" type="button" class="btn btn-secondary">
                <i class="mdi mdi-arrow-left me-1"></i> Back
              </button>
              <button @click="generateInvoice()" type="button" class="btn btn-success flex-grow-1">
                <i class="mdi mdi-checkbox-multiple-marked font-size-16 align-middle me-2"></i> Generate Invoice
              </button>
            </div>
          </div>

        </div>

        <!-- Generating Invoice Loader -->
        <div class="modal-body receipt-billing-modal-body">
          <div class="billing-receipting-loader" v-if="generatingInvoice">
            <div class="loader-modal p-5">
              <div class="d-flex align-items-center justify-content-center p-5 text-center flex-column">
                <div class="spinner-border text-dark m-1" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <p class="pt-4 fw-strong text-uppercase">Generating Invoice Please Wait</p>
              </div>
            </div>
          </div>

          <!-- Generated Invoice Results -->
          <div class="row generated-invoice" v-if="invoiceDetails">
            <div class="col-12">
              <div class="row">
                <div class="col-6">
                  <address>
                    <strong class="text-capitalize">Invoice Prepared for:</strong>
                    <br>Applicant Name: <span class="fw-semibold text-black">{{individualDetails.names}}</span>
                    <br>ID Number: <span class="fw-semibold text-black">{{individualDetails.idNo}}</span>
                    <br>Phone: <span class="fw-semibold text-black">{{billDetails.customerPhoneNumber}}</span>
                    <br>
                    <br> Prepared on {{billDetails.dateCreated}} By {{billDetails.idNo}}</address>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-nowrap vertical-align-middle table-bordered">
                  <thead class="table-dark">
                  <tr class="vertical-align-middle">
                    <th style="width: 70px;">1.</th>
                    <th class="text-uppercase" colspan="3">
                      Invoice No: <span class="fw-bold text-warning">{{billDetails.billNo}}</span>
                    </th>
                  </tr>
                  </thead>
                  <thead class="bg-light">
                  <tr>
                    <th style="width: 70px;">No.</th>
                    <th colspan="2">Item Description</th>
                    <th class="text-end">Amount</th>
                  </tr>
                  </thead>
                  <tbody class="text-uppercase">
                  <tr :key="index" :value="item" v-for="(item, index) in billInfo">
                    <td>{{index+1}}</td>
                    <td colspan="2">
                      <p class="mb-0 p-0 m-0">{{item.feeDescription}}</p>
                    </td>
                    <td class="text-end text-right">KES {{numberFormat(item.billTotal)}}</td>
                  </tr>
                  </tbody>
                  <tfoot class="bg-light text-uppercase table-bordered">
                  <tr>
                    <td></td>
                    <td class="text-right fw-bold text-uppercase" colspan="2">Invoice Sub Total</td>
                    <td class="text-right fw-bold text-uppercase" colspan="2">KES {{numberFormat(billDetails.detailAmount)}}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="text-right fw-bold text-uppercase" colspan="2">Paid Amount</td>
                    <td class="text-right fw-bold text-uppercase text-success">KES {{numberFormat(billDetails.receiptAmount)}}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="text-right fw-bold text-uppercase text-danger" colspan="2">Balance Due</td>
                    <td class="text-right fw-bold text-uppercase text-danger">KES {{numberFormat(billDetails.billBalance)}}</td>
                  </tr>
                  </tfoot>
                </table>
              </div>
              <br>
              <div class="row">
                <div class="col-6">
                  <button @click="printBill()" type="button" class="btn btn-outline-primary w-100">
                    <i class="mdi mdi-printer font-size-16 align-middle me-2"></i> Print Invoice
                  </button>
                </div>
                <div class="col-6">
                  <button type="button" data-bs-toggle="modal" data-bs-target="#medical-payment-modal" class="btn btn-success w-100">
                    <i class="mdi mdi-cash font-size-16 align-middle me-2"></i> Receive Payment
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- End of Medical Certificate Bill Creation Modal -->


  <!-- Payment Modal (Keep existing) -->
  <div class="modal fade" id="medical-payment-modal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" data-bs-keyboard="false" data-bs-backdrop="static">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header d-none">
          <span class="badge badge-soft-success text-uppercase badge font-12px bg-primary-blink text-white">Receive Payment</span>
          <button type="button" class="btn btn-light position-relative p-0 avatar-xs rounded-circle close-modal" data-dismiss="modal" aria-label="Close">
            <span class="avatar-title bg-transparent text-reset font-18px"><i class="bx bx-x"></i></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="d-flex justify-content-between align-items-center">
            <span class="badge badge-soft-success text-uppercase badge font-12px bg-primary-blink text-white">Receive Payment</span>
            <button type="button" class="btn btn-light position-relative p-0 avatar-xs rounded-circle pull-right close-modal" data-dismiss="modal" aria-label="Close">
              <span class="avatar-title bg-transparent text-reset font-18px"><i class="bx bx-x"></i></span>
            </button>
          </div>

          <div class="payment-panel-parent">

            <div v-if="paymentPanel" class="text-center payment-active-panel d-flex flex-column justify-content-around align-items-center sent-success payment-panel">
              <div class="success-image mb-4 pb-4 pt-4">
                <img src="assets/images/bills.svg" height="200" alt="">
              </div>
              <h4 class="text-black fw-bold">{{message}}</h4>
              <p class="text-muted mb-4">The bill has been created successfully. You can print the bill or receive payment for this bill.</p>
              <div class="d-flex w-100 pb-2">
                <button @click="showPaymentMethod()" type="button" class="btn btn-primary btn-block me-3 flex-grow-1">
                  <i class="mdi-cash-check mdi font-size-16 align-middle me-2"></i>
                  Receive Payment
                </button>
                <a @click="printBill()" target="_blank" data-dismiss="" type="button" class="btn btn-outline-secondary waves-effect dismin-modal">Print Bill</a>
              </div>
            </div>

            <div v-if="paymentMethod" class="send-method payment-panel">
              <label for="" class="mb-0 pb-0">Payment Method</label>
              <p><small class="text-muted">How would you like to receive this payment?</small></p>

              <div>
                <div class="accordion" id="medicalAccordion">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="medicalHeadingOne">
                      <button class="accordion-button fw-medium" type="button" data-toggle="collapse" data-target="#medicalCollapseOne" aria-expanded="true" aria-controls="medicalCollapseOne">
                        <div class="flex-shrink-0 me-3">
                          <img class="rounded-circle" src="assets/images/users/mpesa.jpg" alt="Mobile Money" height="65">
                        </div>
                        <div class="d-flex flex-column">
                          <p class="m-0 p-0 text-uppercase fw-semibold">MPESA</p>
                          <p class="mb-0 p-0"><small>A payment request will be sent directly to the customer</small></p>
                        </div>
                      </button>
                    </h2>
                    <div id="medicalCollapseOne" class="accordion-collapse collapse show" aria-labelledby="medicalHeadingOne" data-bs-parent="#medicalAccordion">
                      <div class="accordion-body">
                        <div>
                          <p>A payment request of <strong class="text-black">KES {{numberFormat(billDetails.billBalance)}}</strong> will be sent to the MPESA number you enter below.</p>
                        </div>
                        <div class="form-group">
                          <label for="">MPESA Number</label>
                          <div class="form-floating mb-3">
                            <input v-model="phoneNumber" type="text" class="form-control font-21 text-success form-control-lg" id="medical-phone-input" placeholder="Enter Phone Number">
                            <label for="floatingnameInput">Phone No.</label>
                          </div>
                          <button @click="showTransactionSummary('MPESA')" type="button" class="btn btn-primary btn-block me-3 flex-grow-1">
                            <i class="mdi-cash-check mdi font-size-16 align-middle me-2"></i>
                            Send Payment Request
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="transactionSummary" class="transaction-summary payment-panel">
              <label for="">Transaction Breakdown</label>
              <div class="border p-4 rounded">
                <div class="row">
                  <div class="col-lg-6"><div class="text-muted">Bill No.</div></div>
                  <div class="col-lg-6 align-self-end"><div class="text-right text-black">{{billDetails.billNo}}</div></div>

                  <div class="col-lg-6"><div class="text-muted mt-2">Bill For</div></div>
                  <div class="col-lg-6 align-self-end"><div class="text-right text-black">{{billDetails.incomeTypeDescription}}</div></div>

                  <div class="col-lg-6"><div class="text-muted mt-2">Payment Method</div></div>
                  <div class="col-lg-6 align-self-end"><div class="text-right text-black">{{paymentData.paymentMode}}</div></div>

                  <div class="col-lg-6"><div class="text-muted mt-2">Transaction Amount</div></div>
                  <div class="col-lg-6 align-self-end"><div class="text-right text-black">KES {{numberFormat(billDetails.billBalance)}}</div></div>

                  <div class="col-12 text-black"><hr class="mb-0 pb-0"></div>

                  <div class="col-lg-6 text-uppercase"><div class="text-muted mt-2 font-21">Total</div></div>
                  <div class="col-lg-6 align-self-end text-uppercase"><div class="text-right text-black font-21 fw-bold">KES {{numberFormat(billDetails.billBalance)}}</div></div>
                </div>

                <div class="mpesa-confirmation">
                  <div v-if="paymentData.paymentMode=='MPESA'">
                    <p class="text-muted mt-2">A payment request of <strong class="text-black">KES {{numberFormat(billDetails.billBalance)}}</strong> will be sent to <strong class="text-black">phone number ({{ phoneNumber }})</strong>. Remember to <strong class="text-black">check your phone</strong> to confirm payment by entering your Mpesa PIN.</p>
                  </div>
                  <div>{{message}}</div>
                  <br>
                  <button @click="makePayment()" class="btn btn-primary btn-flex flex-grow-1 waves-effect btn-send waves-light text-center w-100">
                    <div class="d-flex justify-content-center align-items-center">
                      <span class="px-2">Send Request</span>
                      <div class="flip-x"><i class="mdi mdi-reply ms-3 font-16px"></i></div>
                    </div>
                  </button>
                </div>
              </div>
            </div>

            <div v-if="transactionCompleted" class="text-center d-flex flex-column justify-content-around align-items-center sent-success payment-panel">
              <div class="success-image mb-4">
                <img src="assets/images/payment-confirmation-images/sent.svg" height="200" alt="">
              </div>
              <h4 class="text-blink-primary fw-bold">Transaction Complete</h4>
              <p class="text-muted mb-4"><strong class="text-black">KES {{numberFormat(receiptDetails.receiptAmount)}}</strong> has been received for <strong class="text-black">Bill No. {{receiptDetails.billNo}}</strong></p>
              <button @click="printReceipt()" type="button" class="btn btn-primary btn-block me-3 flex-grow-1">
                <i class="mdi-cash-check mdi font-size-16 align-middle me-2"></i>
                Print Receipt
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End of Payment Modal -->


  <!-- ==================== COMPACT BULK UPLOAD MODAL ==================== -->
  <div class="modal fade" id="bulk_upload_modal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="bulkUploadLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content bulk-modal">

        <!-- Compact Header -->
        <div class="bulk-header">
          <div class="bulk-header-left">
            <div class="bulk-header-icon">
              <i class="mdi mdi-account-multiple-plus"></i>
            </div>
            <div>
              <h5 class="bulk-title">Bulk Upload</h5>
              <span class="bulk-subtitle">Upload multiple applicants</span>
            </div>
          </div>
          <button type="button" class="bulk-close" data-dismiss="modal" aria-label="Close">
            <i class="mdi mdi-close"></i>
          </button>
        </div>

        <!-- Compact Step Indicator -->
        <div class="bulk-steps">
          <div class="bulk-step" :class="{ active: bulkCurrentStep === 1, done: bulkCurrentStep > 1 }">
            <span class="step-num">{{ bulkCurrentStep > 1 ? '✓' : '1' }}</span>
            <span class="step-text">Organization</span>
          </div>
          <div class="step-line" :class="{ active: bulkCurrentStep > 1 }"></div>
          <div class="bulk-step" :class="{ active: bulkCurrentStep === 2, done: bulkCurrentStep > 2 }">
            <span class="step-num">{{ bulkCurrentStep > 2 ? '✓' : '2' }}</span>
            <span class="step-text">Upload</span>
          </div>
          <div class="step-line" :class="{ active: bulkCurrentStep > 2 }"></div>
          <div class="bulk-step" :class="{ active: bulkCurrentStep === 3, done: bulkCurrentStep > 3 }">
            <span class="step-num">{{ bulkCurrentStep > 3 ? '✓' : '3' }}</span>
            <span class="step-text">Fee</span>
          </div>
          <div class="step-line" :class="{ active: bulkCurrentStep > 3 }"></div>
          <div class="bulk-step" :class="{ active: bulkCurrentStep === 4 }">
            <span class="step-num">4</span>
            <span class="step-text">Done</span>
          </div>
        </div>

        <!-- Modal Body -->
        <div class="bulk-body">

          <!-- Step 1: Organization -->
          <div v-if="bulkCurrentStep === 1" class="bulk-content">
            <div class="form-row">
              <div class="form-col">
                <label>Organization Name <span class="req">*</span></label>
                <input v-model="bulkOrganization.name" type="text" class="bulk-input" placeholder="e.g., Serena Hotel">
              </div>
              <div class="form-col">
                <label>Contact Person <span class="req">*</span></label>
                <input v-model="bulkOrganization.contactPerson" type="text" class="bulk-input" placeholder="Full name">
              </div>
            </div>
            <div class="form-row">
              <div class="form-col">
                <label>Phone Number <span class="req">*</span></label>
                <input v-model="bulkOrganization.phone" type="text" class="bulk-input" placeholder="0712 345 678">
              </div>
              <div class="form-col">
                <label>Email Address</label>
                <input v-model="bulkOrganization.email" type="email" class="bulk-input" placeholder="email@company.com">
              </div>
            </div>
            <div class="form-row">
              <div class="form-col">
                <label>Sub County <span class="req">*</span></label>
                <select v-model="bulkSubCounty" class="bulk-select">
                  <option value="">Select Sub County</option>
                  <option v-for="(item, index) in subCounties" :value="item" :key="index">{{ item.subCountyName }}</option>
                </select>
              </div>
              <div class="form-col">
                <label>Ward <span class="req">*</span></label>
                <select v-model="bulkWard" class="bulk-select">
                  <option value="">Select Ward</option>
                  <option v-for="(item, index) in bulkWards" :value="item" :key="index">{{ item.wardName }}</option>
                </select>
              </div>
            </div>
          </div>

          <!-- Step 2: Upload File -->
          <div v-if="bulkCurrentStep === 2" class="bulk-content">
            <!-- Organization Badge -->
            <div class="org-badge">
              <i class="mdi mdi-domain"></i>
              <span>{{ bulkOrganization.name }}</span>
              <button @click="bulkGoToStep(1)" class="edit-btn"><i class="mdi mdi-pencil"></i></button>
            </div>

            <!-- Template Link -->
            <div class="template-row">
              <span><i class="mdi mdi-file-excel text-success"></i> Need a template?</span>
              <button @click="downloadBulkTemplate()" class="template-btn">Download Template</button>
            </div>

            <!-- Upload Area -->
            <div
                class="upload-area"
                :class="{ 'drag-active': bulkDragOver, 'has-file': bulkUploadedFile }"
                @dragover.prevent="bulkDragOver = true"
                @dragleave.prevent="bulkDragOver = false"
                @drop.prevent="handleBulkDrop"
                @click="$refs.bulkFileInput.click()"
            >
              <input type="file" ref="bulkFileInput" @change="handleBulkFileUpload" accept=".xlsx,.xls,.csv" style="display: none;">

              <div v-if="!bulkUploadedFile && !bulkProcessingFile" class="upload-placeholder">
                <i class="mdi mdi-cloud-upload-outline"></i>
                <p>Drop file here or <span class="browse">browse</span></p>
                <small>.xlsx, .xls, .csv</small>
              </div>

              <div v-if="bulkProcessingFile" class="upload-processing">
                <div class="spinner-small"></div>
                <span>Processing...</span>
              </div>

              <div v-if="bulkUploadedFile && !bulkProcessingFile" class="upload-file">
                <i class="mdi mdi-file-check text-success"></i>
                <div class="file-info">
                  <span class="file-name">{{ bulkUploadedFile.name }}</span>
                  <span class="file-size">{{ formatFileSize(bulkUploadedFile.size) }}</span>
                </div>
                <button @click.stop="removeBulkFile()" class="remove-btn"><i class="mdi mdi-close"></i></button>
              </div>
            </div>

            <!-- Preview Table -->
            <div v-if="bulkApplicants.length > 0 && !bulkProcessingFile" class="preview-table">
              <div class="preview-header">
                <div class="preview-stats">
                  <span class="stat-badge valid"><i class="mdi mdi-check-circle"></i> {{ bulkValidApplicants.length }} valid</span>
                  <span v-if="bulkInvalidApplicants.length > 0" class="stat-badge invalid"><i class="mdi mdi-alert-circle"></i> {{ bulkInvalidApplicants.length }} invalid</span>
                </div>
                <label class="select-all">
                  <input type="checkbox" v-model="bulkSelectAll" @change="toggleBulkSelectAll">
                  <span>Select All</span>
                </label>
              </div>
              <div class="table-scroll">
                <table class="compact-table">
                  <thead>
                  <tr>
                    <th width="40"></th>
                    <th>Name</th>
                    <th>ID No</th>
                    <th>Phone</th>
                    <th width="50"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(applicant, index) in bulkApplicants" :key="index" :class="{ invalid: !applicant.isValid }">
                    <td><input type="checkbox" v-model="applicant.selected" :disabled="!applicant.isValid"></td>
                    <td>{{ applicant.names }}</td>
                    <td><code>{{ applicant.idNo }}</code></td>
                    <td>{{ applicant.phoneNumber }}</td>
                    <td>
                      <i v-if="applicant.isValid" class="mdi mdi-check-circle text-success"></i>
                      <i v-else class="mdi mdi-alert-circle text-danger" :title="applicant.error"></i>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- Step 3: Fee Selection -->
          <div v-if="bulkCurrentStep === 3" class="bulk-content">
            <!-- Summary Row -->
            <div class="summary-row">
              <div class="summary-item">
                <i class="mdi mdi-domain"></i>
                <div>
                  <small>Organization</small>
                  <strong>{{ bulkOrganization.name }}</strong>
                </div>
              </div>
              <div class="summary-item">
                <i class="mdi mdi-account-group"></i>
                <div>
                  <small>Applicants</small>
                  <strong>{{ bulkSelectedApplicants.length }}</strong>
                </div>
              </div>
              <div class="summary-item highlight">
                <i class="mdi mdi-cash"></i>
                <div>
                  <small>Total</small>
                  <strong>KES {{ numberFormat(bulkTotalAmount) }}</strong>
                </div>
              </div>
            </div>

            <!-- Fee Selection -->
            <div class="form-row">
              <div class="form-col">
                <label>Fee Category <span class="req">*</span></label>
                <select @change="getBulkFeesAndCharges($event)" class="bulk-select">
                  <option value="">Select Category</option>
                  <option v-for="(item, index) in incomeTypes" :value="item.incomeTypeId" :key="index">{{ item.incomeTypeDescription }}</option>
                </select>
              </div>
              <div class="form-col">
                <label>Fee/Charge <span class="req">*</span></label>
                <select @change="selectBulkFee($event)" class="bulk-select">
                  <option value="">Select Fee</option>
                  <option v-for="(item, index) in bulkFeesAndCharges" :value="JSON.stringify(item)" :key="index">{{ item.feeDescription }} — KES {{ numberFormat(item.unitFeeAmount) }}</option>
                </select>
              </div>
            </div>

            <!-- Cost Breakdown -->
            <div v-if="bulkUnitFeeAmount > 0" class="cost-box">
              <div class="cost-row">
                <span>Fee per applicant</span>
                <span>KES {{ numberFormat(bulkUnitFeeAmount) }}</span>
              </div>
              <div class="cost-row">
                <span>Number of applicants</span>
                <span>× {{ bulkSelectedApplicants.length }}</span>
              </div>
              <div class="cost-row total">
                <span>Total Amount</span>
                <span>KES {{ numberFormat(bulkTotalAmount) }}</span>
              </div>
            </div>

            <!-- Applicants Preview -->
            <div class="applicants-preview">
              <span class="preview-label"><i class="mdi mdi-account-check"></i> {{ bulkSelectedApplicants.length }} applicants selected</span>
              <div class="preview-avatars">
                <span v-for="(a, i) in bulkSelectedApplicants.slice(0, 5)" :key="i" class="avatar">{{ a.names.charAt(0) }}</span>
                <span v-if="bulkSelectedApplicants.length > 5" class="avatar more">+{{ bulkSelectedApplicants.length - 5 }}</span>
              </div>
            </div>
          </div>

          <!-- Step 4: Success -->
          <div v-if="bulkCurrentStep === 4" class="bulk-content success-content">
            <div class="success-icon">
              <i class="mdi mdi-check-circle"></i>
            </div>
            <h4>Invoice Created!</h4>
            <p class="success-text">Bill <strong>{{ bulkGeneratedBillNo }}</strong> for <strong>{{ bulkSelectedApplicants.length }}</strong> applicants</p>

            <div class="invoice-card">
              <div class="invoice-row">
                <span>Bill Number</span>
                <strong class="bill-num">{{ bulkGeneratedBillNo }}</strong>
              </div>
              <div class="invoice-row">
                <span>Organization</span>
                <strong>{{ bulkOrganization.name }}</strong>
              </div>
              <div class="invoice-row">
                <span>Applicants</span>
                <strong>{{ bulkSelectedApplicants.length }}</strong>
              </div>
              <div class="invoice-row total-row">
                <span>Total Amount</span>
                <strong>KES {{ numberFormat(bulkTotalAmount) }}</strong>
              </div>
            </div>

            <div class="success-actions">
              <button @click="printBulkBill()" class="btn-outline">
                <i class="mdi mdi-printer"></i> Print
              </button>
              <button @click="resetBulkAndClose()" class="btn-primary" data-dismiss="modal">
                <i class="mdi mdi-check"></i> Done
              </button>
            </div>
          </div>

        </div>

        <!-- Footer -->
        <div class="bulk-footer" v-if="bulkCurrentStep < 4">
          <button v-if="bulkCurrentStep > 1" @click="bulkGoToStep(bulkCurrentStep - 1)" class="btn-back">
            <i class="mdi mdi-arrow-left"></i> Back
          </button>
          <div class="footer-spacer"></div>

          <button v-if="bulkCurrentStep === 1" @click="bulkGoToStep(2)" class="btn-next" :disabled="!isBulkStep1Valid">
            Continue <i class="mdi mdi-arrow-right"></i>
          </button>

          <button v-if="bulkCurrentStep === 2" @click="bulkGoToStep(3)" class="btn-next" :disabled="bulkSelectedApplicants.length === 0">
            Continue <i class="mdi mdi-arrow-right"></i>
          </button>

          <button v-if="bulkCurrentStep === 3" @click="generateBulkInvoice()" class="btn-generate" :disabled="!canGenerateBulkInvoice || bulkGeneratingInvoice">
            <span v-if="bulkGeneratingInvoice"><i class="mdi mdi-loading mdi-spin"></i> Generating...</span>
            <span v-else><i class="mdi mdi-receipt"></i> Generate — KES {{ numberFormat(bulkTotalAmount) }}</span>
          </button>
        </div>

      </div>
    </div>
  </div>
  <!-- End of Compact Bulk Upload Modal -->


</template>

<script>
/* eslint-disable */
import {biller, execute, getRight, health} from "@/api";
import * as XLSX from 'xlsx';

export default {
  name: "ToolBarMedical",
  data() {
    return {
      // Navigation rights
      dashboard: true,
      validation: true,
      inspection: true,
      approval: true,
      declined: true,
      approved: true,
      paidSbp: true,
      unpaidSbp: true,
      unpaidBills: true,
      sbpPaidBills: true,
      sbpMap: true,
      selectedSub: null,

      // Modal state management
      invoiceMessage: 'Next',
      selectedMethod: "",
      searchIdNo: '',
      individualSearch: false,
      individualDetailsResult: false,
      noResultsFound: false,
      assessmentInformation: false,
      activityInformation: false,
      invoiceDetails: false,
      generatingInvoice: false,

      // Individual Details
      individualDetails: {
        id: null,
        idNo: '',
        names: '',
        phoneNumber: '',
        email: '',
        subCountyID: '',
        subCountyName: '',
        wardID: '',
        wardName: '',
        jobTitle: '',
        employer: ''
      },

      // Location data
      subCounty: {},
      ward: {},
      subCounties: [],
      wards: [],

      // Medical Assessment
      testsDone: [''],
      observations: '',
      assessmentConfirmed: false,

      // Billing data
      incomeTypes: [],
      feesAndCharges: [],
      feesAndChargeItems: [],
      billItem: [],
      unitFeeAmount: 0,
      quantity: 1,
      totalAmount: 0,
      feeID: null,
      fiscalYear: '',
      description: '',

      // Other Applicable Charges
      selectedOtherCategory: null,
      selectedCharge: null,
      chargeQuantity: 1,
      addedCharges: [],
      showAllCharges: false,
      loadingOtherCharges: false,
      otherChargeCategories: [],
      feesAndChargesOther: [],

      // Bill Details
      billDetails: {
        id: '',
        billNo: '',
        incomeTypeID: '',
        incomeTypeDescription: '',
        costCenterNo: '',
        accountNo: '',
        feeID: '',
        detailAmount: '',
        receiptAmount: '',
        billBalance: '',
        wardID: '',
        subCountyID: '',
        status: '',
        dateCreated: '',
        customerPhoneNumber: ''
      },
      billInfo: [],

      // Payment data
      paymentPanel: true,
      paymentMethod: false,
      transactionSummary: false,
      transactionCompleted: false,
      phoneNumber: null,
      message: null,
      paymentData: {
        bankReceiptNo: null,
        accNo: null,
        payBillNo: null,
        amount: null,
        phoneNumber: null,
        success: false,
        paymentMode: null,
        sessionNames: null,
        sessionIdNo: null,
        sessionPhoneNumber: null
      },
      receiptDetails: {
        id: '',
        receiptNo: null,
        billNo: '',
        detailAmount: '',
        receiptAmount: '',
        billBalance: ''
      },
      timer: null,

      // ==================== BULK UPLOAD DATA ====================
      bulkCurrentStep: 1,
      bulkDragOver: false,
      bulkUploadedFile: null,
      bulkProcessingFile: false,
      bulkGeneratingInvoice: false,
      bulkSelectAll: false,

      // Organization
      bulkOrganization: {
        name: '',
        contactPerson: '',
        phone: '',
        email: ''
      },

      // Location for bulk
      bulkSubCounty: null,
      bulkWard: null,
      bulkWards: [],

      // Applicants
      bulkApplicants: [],

      // Fee Selection for bulk
      bulkFeesAndCharges: [],
      bulkSelectedFeeData: null,
      bulkUnitFeeAmount: 0,
      bulkFeeID: null,

      // Generated Invoice
      bulkGeneratedBillNo: ''
    }
  },
  computed: {
    totalAddedCharges() {
      return this.addedCharges.reduce((total, item) => total + (item.unitFeeAmount * item.quantity), 0);
    },
    totalComputedAmount() {
      return (parseFloat(this.unitFeeAmount) || 0) + this.totalAddedCharges;
    },
    filteredTestsDone() {
      return this.testsDone.filter(test => test);
    },
    // Bulk Upload computed properties
    isBulkStep1Valid() {
      return this.bulkOrganization.name &&
          this.bulkOrganization.contactPerson &&
          this.bulkOrganization.phone &&
          this.bulkSubCounty &&
          this.bulkWard;
    },
    bulkValidApplicants() {
      return this.bulkApplicants.filter(a => a.isValid);
    },
    bulkInvalidApplicants() {
      return this.bulkApplicants.filter(a => !a.isValid);
    },
    bulkSelectedApplicants() {
      return this.bulkApplicants.filter(a => a.selected && a.isValid);
    },
    bulkTotalAmount() {
      return this.bulkUnitFeeAmount * this.bulkSelectedApplicants.length;
    },
    canGenerateBulkInvoice() {
      return this.bulkSelectedApplicants.length > 0 && this.bulkUnitFeeAmount > 0 && this.bulkFeeID;
    }
  },
  watch: {
    subCounty: function () {
      if (this.subCounty && this.subCounty.subCountyID) {
        this.individualDetails.subCountyName = this.subCounty.subCountyName
        this.individualDetails.subCountyID = this.subCounty.subCountyID
        this.getWards()
      }
    },
    ward: function () {
      if (this.ward && this.ward.wardID) {
        this.individualDetails.wardName = this.ward.wardName
        this.individualDetails.wardID = this.ward.wardID
      }
    },
    bulkSubCounty: function(val) {
      if (val && val.subCountyID) {
        this.getBulkWards();
      }
    }
  },
  mounted() {
    this.getSubCounties()
    this.getIncomeTypes()
    this.getOtherChargeCategories()
  },
  methods: {
    getRight(type) {
      return getRight(type)
    },

    numberFormat(num) {
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num)
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    // ==================== Step 1: Individual/Applicant Methods ====================

    getIndividual() {
      if (!this.searchIdNo) {
        alert("Please enter an ID number")
        return
      }
      this.individualSearch = true
      this.individualDetailsResult = false
      this.noResultsFound = false

      const data = new FormData();
      data.append("function", "getIndividual");
      data.append("idNo", this.searchIdNo);

      execute(data, health)
          .then((res) => {
            this.individualSearch = false
            if (res.data.success) {
              this.individualDetailsResult = true

              const individual = res.data.data.individual
              this.individualDetails = {
                id: individual.id,
                idNo: individual.individualD || individual.idNo || '',
                names: individual.individualNames || individual.names || '',
                phoneNumber: individual.phoneNumber || '',
                email: individual.email || '',
                subCountyID: individual.subCountyID || '',
                subCountyName: individual.subCountyName || '',
                wardID: individual.wardID || '',
                wardName: individual.wardName || '',
                jobTitle: individual.jobTitle || '',
                employer: individual.employer || ''
              }
            } else {
              this.noResultsFound = true
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.individualSearch = false
            this.message = e.message
          });
    },

    registerIndividual() {
      if (!this.individualDetails.names || !this.individualDetails.idNo ||
          !this.individualDetails.phoneNumber || !this.individualDetails.email ||
          !this.individualDetails.subCountyID || !this.individualDetails.wardID) {
        alert("Please fill in all required fields")
        return
      }

      this.invoiceMessage = "Please wait.."

      const data = new FormData();
      data.append("function", "addIndividual");
      data.append("individual", JSON.stringify(this.individualDetails));

      execute(data, health)
          .then((res) => {
            this.invoiceMessage = "Next"
            if (res.data.success) {
              this.proceedToAssessment()
            } else {
              alert(res.data.message)
            }
          })
          .catch((e) => {
            this.invoiceMessage = "Next"
            alert(e.message)
          });
    },

    proceedToAssessment() {
      this.selectedMethod = ""
      this.individualDetailsResult = false
      this.assessmentInformation = true
    },

    // ==================== Step 2: Assessment Methods ====================

    addTest() {
      this.testsDone.push('')
    },

    removeTest(index) {
      this.testsDone.splice(index, 1)
    },

    goBackToApplicant() {
      this.assessmentInformation = false
      this.selectedMethod = 'search'
      this.individualDetailsResult = true
    },

    proceedToBilling() {
      if (!this.assessmentConfirmed) {
        alert("Please confirm the assessment before proceeding")
        return
      }

      this.testsDone = this.testsDone.filter(test => test.trim() !== '')

      if (this.testsDone.length === 0) {
        alert("Please enter at least one test")
        return
      }

      if (!this.observations) {
        alert("Please enter observations/recommendations")
        return
      }

      this.description = JSON.stringify(this.testsDone) + " | " + this.observations

      this.assessmentInformation = false
      this.activityInformation = true
    },

    goBackToAssessment() {
      this.activityInformation = false
      this.assessmentInformation = true
    },

    // ==================== Step 3: Billing Methods ====================

    getSubCounties() {
      const data = new FormData();
      data.append("function", "getSubCounty");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.subCounties = res.data.data.subCounties
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    getWards() {
      this.wards = []
      this.ward = ''
      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", this.subCounty.subCountyID);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.wards = res.data.data.wards
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    getIncomeTypes() {
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      data.append("incomeTypePrefix", "PUBLIC-HEALTH-MEDICAL");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.incomeTypes = res.data.data.incomeTypes
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    getFeesAndCharges(event) {
      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", event.target.value);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.feesAndCharges = res.data.data.feesAndCharges
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    selectedSubCategory(event) {
      const data = JSON.parse(event.target.value)
      this.feeID = data.feeId
      this.unitFeeAmount = data.unitFeeAmount
      this.feesAndChargeItems = []
      this.feesAndChargeItems.push(data)

      this.feesAndChargeItems = this.feesAndChargeItems.map(item => {
        item.quantity = this.quantity;
        item.customer = `Applicant ID: ${this.individualDetails.idNo}`
        return item;
      });
    },

    // ==================== Other Applicable Charges Methods ====================

    getOtherChargeCategories() {
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      data.append("incomeTypePrefix", "PUBLIC-HEALTH-MEDICAL");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.otherChargeCategories = res.data.data.incomeTypes
            } else {
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },

    toggleCharges() {
      this.showAllCharges = !this.showAllCharges;
      this.getOtherChargeCategories();
    },

    handleCategoryChange() {
      if (this.selectedOtherCategory) {
        this.getFeesAndChargesOther(this.selectedOtherCategory.incomeTypeId);
      } else {
        this.feesAndChargesOther = [];
      }
      this.selectedCharge = null;
    },

    getFeesAndChargesOther(incomeTypeId) {
      this.feesAndChargesOther = [];
      this.loadingOtherCharges = true;
      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", incomeTypeId);

      execute(data, biller)
          .then((res) => {
            this.loadingOtherCharges = false;
            if (res.data.success) {
              this.feesAndChargesOther = res.data.data.feesAndCharges;
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.loadingOtherCharges = false;
            this.message = e.message;
          });
    },

    addChargeToList() {
      if (!this.selectedCharge) return;

      const existingIndex = this.addedCharges.findIndex(item => item.feeId === this.selectedCharge.feeId);

      if (existingIndex !== -1) {
        this.addedCharges[existingIndex].quantity += this.chargeQuantity;
      } else {
        this.addedCharges.push({
          ...this.selectedCharge,
          quantity: this.chargeQuantity
        });
      }

      this.selectedCharge = null;
      this.chargeQuantity = 1;
    },

    removeCharge(index) {
      this.addedCharges.splice(index, 1);
    },

    // ==================== Generate Invoice ====================

    generateInvoice() {
      if (this.feesAndChargeItems.length === 0) {
        alert("Please select a fee category")
        return
      }

      if (this.addedCharges && this.addedCharges.length > 0) {
        this.addedCharges.forEach(charge => {
          const exists = this.feesAndChargeItems.some(feeItem => feeItem.feeId === charge.feeId);
          if (!exists) {
            this.feesAndChargeItems.push({
              ...charge,
              quantity: charge.quantity || 1,
              customer: `Applicant ID: ${this.individualDetails.idNo}`
            });
          }
        });
      }

      this.addToBill();
    },

    addToBill() {
      this.billItem = []
      this.totalAmount = 0

      for (const { typeDescription, feeId, feeDescription, unitFeeAmount, accountNo, costCenterNo, incomeTypeId, customer, quantity } of this.feesAndChargeItems) {
        const qty = quantity || this.quantity;
        this.totalAmount += parseFloat(unitFeeAmount * qty);

        this.billItem.push({
          fiscalYear: this.fiscalYear,
          typeDescription,
          feeDescription,
          unitFeeAmount: unitFeeAmount * qty,
          accountNo,
          costCenterNo,
          incomeTypeId,
          revenueStreamItem: this.individualDetails.names,
          feeId,
          amount: unitFeeAmount * qty,
          customer: `Applicant ID: ${this.individualDetails.idNo}`,
          zone: sessionStorage.getItem("sessionZone"),
          subCountyID: this.individualDetails.subCountyID,
          subCountyName: this.individualDetails.subCountyName,
          wardID: this.individualDetails.wardID,
          wardName: this.individualDetails.wardName,
          idNo: sessionStorage.getItem("sessionIdNo"),
          phoneNumber: sessionStorage.getItem("sessionPhoneNumber"),
          names: sessionStorage.getItem("sessionNames"),
          customerPhoneNumber: this.individualDetails.phoneNumber,
          description: this.description,
          customerName: this.individualDetails.names,
        });
      }

      this.generateBillRequest()
    },

    generateBillRequest() {
      this.activityInformation = false
      this.generatingInvoice = true
      this.paymentMethod = false;
      this.paymentPanel = true;
      this.transactionSummary = false;
      this.transactionCompleted = false
      this.message = "Generating Bill...please wait..."

      const data = new FormData();
      data.append("function", "generateBill3");
      data.append("billItem", JSON.stringify(this.billItem));

      execute(data, biller)
          .then((res) => {
            this.generatingInvoice = false
            this.message = res.data.message
            if (res.data.success) {
              this.invoiceDetails = true
              this.billDetails = res.data.data.bill.billDetails
              this.billInfo = res.data.data.bill.billInfo
              this.paymentData.amount = res.data.data.bill.billDetails.billBalance
              this.paymentData.accNo = res.data.data.bill.billDetails.billNo
              this.paymentData.payBillNo = res.data.data.billGenerated.payBillNo
              this.paymentData.sessionPhoneNumber = sessionStorage.getItem("sessionPhoneNumber")
              this.paymentData.sessionNames = sessionStorage.getItem("sessionNames")
              this.paymentData.sessionIdNo = sessionStorage.getItem("sessionIdNo")

              this.phoneNumber = this.individualDetails.phoneNumber
            } else {
              this.generatingInvoice = false
              this.invoiceDetails = false
              alert(res.data.message);
            }
          })
          .catch((e) => {
            this.generatingInvoice = false
            this.message = e.message
          });
    },

    // ==================== Print Methods ====================

    printBill() {
      localStorage['params'] = JSON.stringify({
        billNo: this.billDetails.billNo
      })
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    },

    printReceipt() {
      if (this.receiptDetails.receiptNo == null) {
        alert("Try again later");
      } else {
        localStorage['params'] = JSON.stringify({
          receiptNo: this.receiptDetails.receiptNo
        })
        const routeData = this.$router.resolve({ name: 'receipt' });
        window.open(routeData.href, '_blank');
      }
    },

    // ==================== Payment Methods ====================

    showPaymentMethod() {
      this.paymentMethod = true;
      this.paymentPanel = false;
      this.transactionSummary = false;
      this.transactionCompleted = false
    },

    showTransactionSummary(paymentMode) {
      this.paymentData.paymentMode = paymentMode

      if (paymentMode === "MPESA") {
        if (this.phoneNumber == null || this.phoneNumber === '') {
          alert("Enter phone number");
          return;
        }
      }

      this.paymentMethod = false;
      this.paymentPanel = false;
      this.transactionSummary = true;
      this.transactionCompleted = false
    },

    makePayment() {
      if (this.paymentData.paymentMode === "MPESA") {
        if (this.phoneNumber == null || this.phoneNumber === '') {
          alert("Enter phone number");
          return;
        }
      }

      this.message = "Payment Request sent";
      this.paymentData.phoneNumber = this.phoneNumber

      const data = new FormData();
      data.append("function", "makePayment");
      data.append("paymentData", JSON.stringify(this.paymentData));

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.paymentMethod = false;
              this.paymentPanel = false;
              this.timer = setInterval(() => {
                this.checkPayment();
              }, 3000);
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },

    checkPayment() {
      this.randomNumber = Math.floor(Math.random() * 3) + 1
      if (this.randomNumber === 1) {
        this.message = "Waiting for payment.";
      }
      if (this.randomNumber === 2) {
        this.message = "Waiting for payment..";
      }
      if (this.randomNumber === 3) {
        this.message = "Waiting for payment...";
      }

      const data = new FormData();
      data.append("function", "checkPayment");
      data.append("accountRef", this.paymentData.accNo);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.message = null;
              clearInterval(this.timer);
              this.paymentData.success = false;
              this.receiptDetails = res.data.data.receipt.receiptDetails
              this.transactionSummary = false
              this.transactionCompleted = true
            }
          })
          .catch((e) => {
            alert(e.message);
          });
    },

    // ==================== BULK UPLOAD METHODS ====================

    bulkGoToStep(step) {
      this.bulkCurrentStep = step;
    },

    getBulkWards() {
      this.bulkWards = [];
      this.bulkWard = null;
      const data = new FormData();
      data.append("function", "getWards");
      data.append("subCountyID", this.bulkSubCounty.subCountyID);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.bulkWards = res.data.data.wards;
            }
          })
          .catch((e) => console.error(e));
    },

    downloadBulkTemplate() {
      const template = [
        {
          'Full Names': 'John Doe',
          'ID Number': '12345678',
          'Phone Number': '0712345678',
          'Email': 'john@example.com',
          'Job Title': 'Food Handler'
        },
        {
          'Full Names': 'Jane Smith',
          'ID Number': '87654321',
          'Phone Number': '0723456789',
          'Email': 'jane@example.com',
          'Job Title': 'Chef'
        }
      ];

      const ws = XLSX.utils.json_to_sheet(template);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Applicants');

      ws['!cols'] = [
        { wch: 25 },
        { wch: 15 },
        { wch: 15 },
        { wch: 25 },
        { wch: 20 }
      ];

      XLSX.writeFile(wb, 'Medical_Certificate_Applicants_Template.xlsx');
    },

    handleBulkDrop(e) {
      this.bulkDragOver = false;
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        this.processBulkFile(files[0]);
      }
    },

    handleBulkFileUpload(e) {
      const file = e.target.files[0];
      if (file) {
        this.processBulkFile(file);
      }
    },

    removeBulkFile() {
      this.bulkUploadedFile = null;
      this.bulkApplicants = [];
      if (this.$refs.bulkFileInput) {
        this.$refs.bulkFileInput.value = '';
      }
    },

    processBulkFile(file) {
      this.bulkUploadedFile = file;
      this.bulkProcessingFile = true;
      this.bulkApplicants = [];

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);

          this.bulkApplicants = jsonData.map((row, index) => {
            const applicant = {
              rowIndex: index + 2,
              names: row['Full Names'] || row['Names'] || row['Name'] || '',
              idNo: String(row['ID Number'] || row['ID No'] || row['IDNo'] || '').trim(),
              phoneNumber: String(row['Phone Number'] || row['Phone'] || row['PhoneNumber'] || '').trim(),
              email: row['Email'] || row['E-mail'] || '',
              jobTitle: row['Job Title'] || row['JobTitle'] || row['Occupation'] || '',
              selected: true,
              isValid: true,
              error: ''
            };

            if (!applicant.names) {
              applicant.isValid = false;
              applicant.error = 'Full Names is required';
            } else if (!applicant.idNo) {
              applicant.isValid = false;
              applicant.error = 'ID Number is required';
            } else if (!applicant.phoneNumber) {
              applicant.isValid = false;
              applicant.error = 'Phone Number is required';
            }

            return applicant;
          });

          this.bulkProcessingFile = false;
        } catch (error) {
          console.error('Error processing file:', error);
          this.bulkProcessingFile = false;
          alert('Error processing file. Please ensure it is a valid Excel or CSV file.');
        }
      };
      reader.readAsArrayBuffer(file);
    },

    toggleBulkSelectAll() {
      this.bulkApplicants.forEach(a => {
        if (a.isValid) {
          a.selected = this.bulkSelectAll;
        }
      });
    },

    getBulkFeesAndCharges(event) {
      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", event.target.value);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.bulkFeesAndCharges = res.data.data.feesAndCharges;
            }
          })
          .catch((e) => console.error(e));
    },

    selectBulkFee(event) {
      const fee = JSON.parse(event.target.value);
      this.bulkSelectedFeeData = fee;
      this.bulkUnitFeeAmount = parseFloat(fee.unitFeeAmount);
      this.bulkFeeID = fee.feeId;
    },

    async generateBulkInvoice() {
      if (!this.canGenerateBulkInvoice) {
        alert('Please select a fee and ensure applicants are selected');
        return;
      }

      this.bulkGeneratingInvoice = true;

      try {
        // Step 1: Register all individuals
        for (const applicant of this.bulkSelectedApplicants) {
          const individualData = {
            names: applicant.names,
            idNo: applicant.idNo,
            phoneNumber: applicant.phoneNumber,
            email: applicant.email || 'N/A',
            subCountyID: this.bulkSubCounty.subCountyID,
            subCountyName: this.bulkSubCounty.subCountyName,
            wardID: this.bulkWard.wardID,
            wardName: this.bulkWard.wardName,
            jobTitle: applicant.jobTitle,
            employer: this.bulkOrganization.name
          };

          const regData = new FormData();
          regData.append("function", "addIndividual");
          regData.append("individual", JSON.stringify(individualData));
          await execute(regData, health);
        }

        // Step 2: Build bill items for all applicants
        const billItems = this.bulkSelectedApplicants.map(applicant => ({
          fiscalYear: '',
          typeDescription: this.bulkSelectedFeeData.typeDescription,
          feeDescription: this.bulkSelectedFeeData.feeDescription,
          unitFeeAmount: this.bulkUnitFeeAmount,
          accountNo: this.bulkSelectedFeeData.accountNo,
          costCenterNo: this.bulkSelectedFeeData.costCenterNo,
          incomeTypeId: this.bulkSelectedFeeData.incomeTypeId,
          revenueStreamItem: applicant.names,
          feeId: this.bulkFeeID,
          amount: this.bulkUnitFeeAmount,
          customer: `Applicant ID: ${applicant.idNo}`,
          zone: sessionStorage.getItem("sessionZone"),
          subCountyID: this.bulkSubCounty.subCountyID,
          subCountyName: this.bulkSubCounty.subCountyName,
          wardID: this.bulkWard.wardID,
          wardName: this.bulkWard.wardName,
          idNo: sessionStorage.getItem("sessionIdNo"),
          phoneNumber: sessionStorage.getItem("sessionPhoneNumber"),
          names: sessionStorage.getItem("sessionNames"),
          customerPhoneNumber: this.bulkOrganization.phone,
          description: `Bulk Medical Certificate - ${this.bulkOrganization.name}`,
          customerName: this.bulkOrganization.name,
          quantity: 1
        }));

        // Step 3: Generate single bill with all items
        const billData = new FormData();
        billData.append("function", "generateBill3");
        billData.append("billItem", JSON.stringify(billItems));

        const billRes = await execute(billData, biller);

        if (billRes.data.success) {
          this.bulkGeneratedBillNo = billRes.data.data.bill.billDetails.billNo;
          this.bulkCurrentStep = 4;
        } else {
          alert(billRes.data.message || 'Failed to generate invoice');
        }
      } catch (error) {
        console.error('Error generating invoice:', error);
        alert('Error generating invoice: ' + error.message);
      } finally {
        this.bulkGeneratingInvoice = false;
      }
    },

    printBulkBill() {
      localStorage['params'] = JSON.stringify({ billNo: this.bulkGeneratedBillNo });
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    },

    resetBulkAndClose() {
      this.bulkCurrentStep = 1;
      this.bulkApplicants = [];
      this.bulkUploadedFile = null;
      this.bulkOrganization = {
        name: '',
        contactPerson: '',
        phone: '',
        email: ''
      };
      this.bulkSubCounty = null;
      this.bulkWard = null;
      this.bulkSelectedFeeData = null;
      this.bulkUnitFeeAmount = 0;
      this.bulkFeeID = null;
      this.bulkGeneratedBillNo = '';
    }

  }
}
</script>

<style scoped>
/* ==================== COMPACT BULK UPLOAD STYLES ==================== */

.bulk-modal {
  border: none;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

/* Header */
.bulk-header {
  background: linear-gradient(135deg, #059669 0%, #047857 100%);
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.bulk-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.bulk-header-icon {
  width: 40px;
  height: 40px;
  background: rgba(255,255,255,0.2);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bulk-header-icon i {
  font-size: 20px;
  color: white;
}

.bulk-title {
  color: white;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.bulk-subtitle {
  color: rgba(255,255,255,0.8);
  font-size: 12px;
}

.bulk-close {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(255,255,255,0.2);
  border: none;
  color: white;
  cursor: pointer;
  transition: background 0.2s;
}

.bulk-close:hover {
  background: rgba(255,255,255,0.3);
}

/* Steps */
.bulk-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 20px;
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
  gap: 8px;
}

.bulk-step {
  display: flex;
  align-items: center;
  gap: 6px;
}

.step-num {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  transition: all 0.3s;
}

.bulk-step.active .step-num {
  background: #059669;
  color: white;
}

.bulk-step.done .step-num {
  background: #059669;
  color: white;
}

.step-text {
  font-size: 12px;
  color: #9ca3af;
  font-weight: 500;
}

.bulk-step.active .step-text {
  color: #059669;
  font-weight: 600;
}

.step-line {
  width: 40px;
  height: 2px;
  background: #e5e7eb;
  transition: background 0.3s;
}

.step-line.active {
  background: #059669;
}

/* Body */
.bulk-body {
  padding: 20px;
  max-height: 450px;
  overflow-y: auto;
}

.bulk-content {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Form Elements */
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.form-col {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-col label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.req {
  color: #ef4444;
}

.bulk-input,
.bulk-select {
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  transition: all 0.2s;
  background: white;
}

.bulk-input:focus,
.bulk-select:focus {
  outline: none;
  border-color: #059669;
  box-shadow: 0 0 0 3px rgba(5, 150, 105, 0.1);
}

.bulk-input::placeholder {
  color: #9ca3af;
}

/* Organization Badge */
.org-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  margin-bottom: 16px;
}

.org-badge i {
  color: #059669;
}

.org-badge span {
  font-size: 13px;
  font-weight: 600;
  color: #166534;
}

.edit-btn {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: white;
  border: 1px solid #bbf7d0;
  color: #059669;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
}

.edit-btn:hover {
  background: #059669;
  color: white;
}

/* Template Row */
.template-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 8px;
  margin-bottom: 16px;
}

.template-row span {
  font-size: 12px;
  color: #1e40af;
}

.template-btn {
  padding: 6px 12px;
  background: white;
  border: 1px solid #3b82f6;
  border-radius: 6px;
  color: #3b82f6;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.template-btn:hover {
  background: #3b82f6;
  color: white;
}

/* Upload Area */
.upload-area {
  border: 2px dashed #d1d5db;
  border-radius: 10px;
  padding: 24px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  background: #fafafa;
  margin-bottom: 16px;
}

.upload-area:hover,
.upload-area.drag-active {
  border-color: #059669;
  background: #f0fdf4;
}

.upload-area.has-file {
  border-style: solid;
  border-color: #059669;
  background: #f0fdf4;
  padding: 16px;
}

.upload-placeholder i {
  font-size: 36px;
  color: #9ca3af;
  margin-bottom: 8px;
}

.upload-placeholder p {
  margin: 0;
  color: #6b7280;
  font-size: 13px;
}

.upload-placeholder .browse {
  color: #059669;
  font-weight: 600;
}

.upload-placeholder small {
  color: #9ca3af;
  font-size: 11px;
}

.upload-processing {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #6b7280;
}

.spinner-small {
  width: 20px;
  height: 20px;
  border: 2px solid #e5e7eb;
  border-top-color: #059669;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.upload-file {
  display: flex;
  align-items: center;
  gap: 12px;
}

.upload-file > i {
  font-size: 28px;
}

.file-info {
  flex: 1;
  text-align: left;
}

.file-name {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}

.file-size {
  font-size: 11px;
  color: #6b7280;
}

.remove-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #fee2e2;
  border: none;
  color: #ef4444;
  cursor: pointer;
}

.remove-btn:hover {
  background: #ef4444;
  color: white;
}

/* Preview Table */
.preview-table {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}

.preview-stats {
  display: flex;
  gap: 8px;
}

.stat-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}

.stat-badge.valid {
  background: #dcfce7;
  color: #166534;
}

.stat-badge.invalid {
  background: #fee2e2;
  color: #991b1b;
}

.select-all {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #6b7280;
  cursor: pointer;
}

.table-scroll {
  max-height: 180px;
  overflow-y: auto;
}

.compact-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.compact-table th {
  padding: 8px 10px;
  text-align: left;
  font-weight: 600;
  color: #6b7280;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
}

.compact-table td {
  padding: 8px 10px;
  border-bottom: 1px solid #f3f4f6;
  color: #374151;
}

.compact-table tr.invalid {
  background: #fef2f2;
}

.compact-table code {
  padding: 2px 6px;
  background: #f3f4f6;
  border-radius: 4px;
  font-size: 11px;
}

/* Summary Row */
.summary-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  background: #f9fafb;
  border-radius: 8px;
}

.summary-item i {
  font-size: 20px;
  color: #6b7280;
}

.summary-item div {
  display: flex;
  flex-direction: column;
}

.summary-item small {
  font-size: 10px;
  color: #9ca3af;
  text-transform: uppercase;
}

.summary-item strong {
  font-size: 14px;
  color: #111827;
}

.summary-item.highlight {
  background: linear-gradient(135deg, #059669, #047857);
}

.summary-item.highlight i,
.summary-item.highlight small,
.summary-item.highlight strong {
  color: white;
}

/* Cost Box */
.cost-box {
  background: #f9fafb;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
}

.cost-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 13px;
  color: #6b7280;
  border-bottom: 1px solid #e5e7eb;
}

.cost-row:last-child {
  border-bottom: none;
}

.cost-row.total {
  background: #059669;
  margin: 8px -16px -12px;
  padding: 12px 16px;
  border-radius: 0 0 8px 8px;
  color: white;
  font-weight: 600;
}

/* Applicants Preview */
.applicants-preview {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background: #f9fafb;
  border-radius: 8px;
}

.preview-label {
  font-size: 12px;
  color: #6b7280;
}

.preview-label i {
  color: #059669;
  margin-right: 4px;
}

.preview-avatars {
  display: flex;
  gap: -8px;
}

.avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #059669, #047857);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  border: 2px solid white;
  margin-left: -8px;
}

.avatar:first-child {
  margin-left: 0;
}

.avatar.more {
  background: #e5e7eb;
  color: #6b7280;
  font-size: 10px;
}

/* Success Content */
.success-content {
  text-align: center;
  padding: 20px 0;
}

.success-icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(135deg, #059669, #047857);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  animation: popIn 0.4s ease;
}

@keyframes popIn {
  0% { transform: scale(0); }
  70% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

.success-icon i {
  font-size: 32px;
  color: white;
}

.success-content h4 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #059669;
}

.success-text {
  color: #6b7280;
  font-size: 13px;
  margin-bottom: 20px;
}

.invoice-card {
  max-width: 280px;
  margin: 0 auto 20px;
  background: #f9fafb;
  border-radius: 10px;
  padding: 16px;
  text-align: left;
}

.invoice-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #e5e7eb;
  font-size: 12px;
}

.invoice-row:last-child {
  border-bottom: none;
}

.invoice-row span {
  color: #6b7280;
}

.invoice-row strong {
  color: #111827;
}

.invoice-row .bill-num {
  color: #3b82f6;
  font-family: monospace;
}

.invoice-row.total-row {
  background: #059669;
  margin: 12px -16px -16px;
  padding: 12px 16px;
  border-radius: 0 0 10px 10px;
}

.invoice-row.total-row span,
.invoice-row.total-row strong {
  color: white;
}

.success-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.btn-outline,
.btn-primary {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}

.btn-outline {
  background: white;
  border: 1px solid #d1d5db;
  color: #374151;
}

.btn-outline:hover {
  border-color: #059669;
  color: #059669;
}

.btn-primary {
  background: linear-gradient(135deg, #059669, #047857);
  border: none;
  color: white;
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);
}

/* Footer */
.bulk-footer {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
}

.footer-spacer {
  flex: 1;
}

.btn-back,
.btn-next,
.btn-generate {
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}

.btn-back {
  background: white;
  border: 1px solid #e5e7eb;
  color: #6b7280;
}

.btn-back:hover {
  border-color: #d1d5db;
  background: #f9fafb;
}

.btn-next {
  background: linear-gradient(135deg, #059669, #047857);
  border: none;
  color: white;
}

.btn-next:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(5, 150, 105, 0.3);
}

.btn-next:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-generate {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  border: none;
  color: white;
}

.btn-generate:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
}

.btn-generate:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Responsive */
@media (max-width: 576px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .summary-row {
    grid-template-columns: 1fr;
  }

  .bulk-steps {
    gap: 4px;
  }

  .step-text {
    display: none;
  }

  .step-line {
    width: 24px;
  }
}
</style>